import React, { useEffect, useRef } from "react";
import Container from "../../UI/Container/Container";
import classes from "./Message.module.css";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const Message = (props) => {
  gsap.registerPlugin(ScrollTrigger);

  const textRef = useRef(null);

  useEffect(() => {
    const timeline = gsap.timeline({
      scrollTrigger: {
        trigger: textRef.current,
        start: "top 50%",
      },
    });

    timeline.to(textRef.current, { opacity: 1, duration: 1, ease: "sine.out" });
  });

  return (
    <div className={classes.Message}>
      <Container>
        <p ref={textRef}>
        Dickinson integrates sustainability into its academics, facilities, operations
and campus culture and has received continual recognition from the
Association for the Advancement of Sustainability in Higher Education,
Sierra Club, Sustainable Endowments Institute, Princeton Review and
Second Nature. Dickinson is also a member of the EcoLeague, which offers
semester-exchange options with other top “green” colleges located in
diverse geographic regions across the country.
        </p>
      </Container>
    </div>
  );
};

export default Message;
